import { createFileRoute, redirect } from "@tanstack/react-router";

// Retired city + trade combination pages now point at the city landing page.
export const Route = createFileRoute("/contractor-websites/$city/$trade")({
  beforeLoad: ({ params }) => {
    throw redirect({
      to: "/contractor-websites/$city",
      params: { city: params.city },
      replace: true,
      statusCode: 301,
    });
  },
});
